import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/nameInput/styles.scss';export default {
  "nameInput": "_nameInput_1u2h7_1",
  "group": "_group_1u2h7_5",
  "label": "_label_1u2h7_9"
};